import { apiFetch } from '@/lib/api';
import type { Settlement } from '@domain/types';

export type SettlementInput = {
  groupId: string;
  fromMemberId: string;
  toMemberId: string;
  amountMinor: number;
  date: string;
  note?: string | null;
};

export async function listSettlements(groupId: string): Promise<Settlement[]> {
  return apiFetch<Settlement[]>(`/groups/${groupId}/settlements`);
}

export async function createSettlement(input: SettlementInput): Promise<Settlement> {
  if (input.fromMemberId === input.toMemberId) {
    throw new Error('A settlement needs two different members.');
  }
  if (input.amountMinor <= 0) {
    throw new Error('A settlement amount must be greater than zero.');
  }

  return apiFetch<Settlement>('/settlements', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function deleteSettlement(id: string): Promise<void> {
  await apiFetch<void>(`/settlements/${id}`, {
    method: 'DELETE',
  });
}
